import { useEffect, useState } from "react";
import { engagementApi, track, useViewed } from "@/lib/engagement";

// Accadde oggi: 3 eventi della data, estratti brevi da Wikipedia con attribuzione.
export function OnThisDay() {
  const [events, setEvents] = useState([]);
  useEffect(() => { engagementApi.onThisDay().then((r) => setEvents(r.events || [])).catch(() => {}); }, []);
  const ref = useViewed("on_this_day_viewed", events.length > 0);
  if (!events.length) return null;
  const day = new Date().toLocaleDateString("it-IT", { day: "numeric", month: "long", timeZone: "Europe/Rome" });
  return (
    <section ref={ref} data-testid="on-this-day" className="rounded-2xl border border-hair bg-surfaceSecondary p-5 sm:p-6">
      <h2 className="font-serif text-xl font-semibold text-onSurface">Accadde oggi</h2>
      <p className="text-sm text-subtle mb-4">{day}, negli anni</p>
      <ul className="space-y-4">
        {events.map((e, i) => (
          <li key={`${e.year}-${i}`}>
            <a href={e.url} target="_blank" rel="noopener noreferrer" data-testid={`on-this-day-item-${i}`}
              onClick={() => track("on_this_day_clicked", { year: e.year })} className="group flex gap-3">
              {e.image && <img src={e.image} alt="" loading="lazy" className="w-16 h-16 rounded-lg object-cover shrink-0 bg-hair" />}
              <span className="min-w-0">
                <span className="font-serif text-lg font-semibold text-brand tabular-nums">{e.year}</span>
                <span className="block text-sm font-semibold text-onSurface group-hover:text-brand transition-colors">{e.title}</span>
                <span className="block text-sm text-subtle line-clamp-2">{e.text}</span>
              </span>
            </a>
          </li>
        ))}
      </ul>
      <p className="mt-4 font-mono text-[10px] text-subtle">Fonte: Wikipedia · testi CC BY-SA 4.0</p>
    </section>
  );
}
